<div [class]="alertClass">
  <mat-icon fontSet="material-icons-outlined" [class]="iconClass">{{icon}}</mat-icon>
  <div class="items-start" [ngClass]="[paddingLeftIcon, lineHeight ] ">
    <ng-container *ngTemplateOutlet="messageTemplate || default"></ng-container>
    <span *ngIf="subtitle" style="display: block" class="fs-12 w-all">{{ subtitle }}</span>
    <span *ngIf="link" class="fs-12 mt-8">
      <a (click)="clickLinkEvent.emit()" style="text-decoration: underline; cursor: pointer">{{ link }}</a>
    </span>
  </div>
</div>

<ng-template #default>
  <span [innerHtml]="message" style="display: block" class="w-all" [class]="subtitle ? 'fw-600' : ''"></span>
</ng-template>
